import { render, staticRenderFns } from "./DefaultSelect.vue.js?vue&type=template&id=887251c8!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DefaultSelect.vue?vue&type=template&id=887251c8"
import script from "./DefaultSelect.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DefaultSelect.vue?vue&type=script&lang=js"
export * from "./DefaultSelect.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DefaultSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports